import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

import { getAssetUrl } from "../../utils/url";
import { get } from "../../modules/env";

@customElement("bp-logo")
export class Logo extends LitElement {
  static styles = css`
    :host {
      --height: var(--logo-height, var(--size-4));

      display: block;
    }

    img {
      display: block;
    }
  `;

  @property()
  title: string = "BibleProject Logo";

  @property()
  variant: "default" | "logo-mark" | "word-mark" = "default";

  @property()
  lang: "en" | "es" = (get("LANGUAGE") ?? "en") as "en" | "es";

  get src() {
    switch (this.variant) {
      case "logo-mark":
        return getAssetUrl("/bibleproject-logo-mark.svg");
      case "word-mark":
        if (this.lang === "es") {
          return getAssetUrl("/proyectobiblia-word-mark.svg");
        }

        return getAssetUrl("/bibleproject-word-mark.svg");
      default:
        if (this.lang === "es") {
          return "/proyectobiblia.svg";
        }

        return getAssetUrl("/bibleproject.svg");
    }
  }

  render() {
    return html`
      <img
        src="${this.src}"
        style="height: var(--height);"
        title="${this.title}"
      />
    `;
  }
}
